import { render } from "./SignIn.vue?vue&type=template&id=70225b0c"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"

import "./SignIn.vue?vue&type=style&index=0&id=70225b0c&lang=css"
script.render = render

export default script